import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth/auth-rx.service';
import { ARIA_TOAST_SERVICE } from 'app/tokens/toast.tokens';
import { environment } from '@environment/environment';
import { skipAuthErrorPaths } from '@environment/environment.commons';
import { saveReturnUrl } from '@app/utils/util/return-url';
import { catchError, throwError } from 'rxjs';

/**
 * Lista de prefijos de APIs internas para detectar requests propios.
 * Debe mantenerse sincronizada con auth.interceptor.ts
 */
const INTERNAL_API_PREFIXES = [
  environment.BASE_API,
  environment.API_AUTH,
  environment.API_AUTH_LOGIN,
  environment.API_ARIA_CORE,
  environment.CUSTOMER_API,
  environment.ORDERS_API,
  environment.UBIGEO_API,
  environment.API_FILE_MANAGER,
].filter(Boolean);

function isInternalApi(url: string): boolean {
  return INTERNAL_API_PREFIXES.some(prefix => prefix && url.startsWith(prefix));
}

function isLoginRequest(url: string): boolean {
  return url.startsWith(environment.API_AUTH_LOGIN) && url.includes('/session/login');
}

function isSkipAuthErrorUrl(url: string): boolean {
  return skipAuthErrorPaths.some(path => url.includes(path));
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const toastService = inject(ARIA_TOAST_SERVICE);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && isInternalApi(req.url) && !isLoginRequest(req.url) && !isSkipAuthErrorUrl(req.url)) {
        // Antes de limpiar: guardamos dónde estaba para volver ahí tras el login.
        saveReturnUrl(router.url);
        authService.clearAuthData();
        router.navigate(['/auth/login']);
        toastService.showError('', 'Su sesión ha expirado, por favor inicie sesión nuevamente', 'bottom');
      }

      return throwError(() => error);
    })
  );
};
